import { Alert, Avatar, Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";

export default function TitlePage({
  title,
  image_icon,
  children,
  userTitle,
  warning,
}) {
  return (
    // <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
    <Stack direction="column" spacing={2}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt="Logo Title"
            src={image_icon}
            variant="rounded"
            sx={{ width: 56, height: 56, mr: 2 }}
          />
          <Typography variant="h6" sx={{ mr: 1 }}>
            {title}
          </Typography>
          {userTitle}
        </Box>
        {warning && <Alert severity="warning">{warning}</Alert>}
      </Box>
      {children}
    </Stack>
    // </Paper>
  );
}
